import { render, staticRenderFns } from "./AnnouncementSelectTargetGroup.vue?vue&type=template&id=2d2fcce0&scoped=true"
import script from "./AnnouncementSelectTargetGroup.vue?vue&type=script&lang=js"
export * from "./AnnouncementSelectTargetGroup.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementSelectTargetGroup.vue?vue&type=style&index=0&id=2d2fcce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fcce0",
  null
  
)

export default component.exports